var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFullScreen = function SvgIconFullScreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 2.375L13.6958 4.19583L11.4079 6.46792L12.5321 7.59208L14.8042 5.30417L16.625 7.125V2.375H11.875ZM2.375 7.125L4.19583 5.30417L6.46792 7.59208L7.59208 6.46792L5.30417 4.19583L7.125 2.375H2.375V7.125ZM7.125 16.625L5.30417 14.8042L7.59208 12.5321L6.46792 11.4079L4.19583 13.6958L2.375 11.875V16.625H7.125ZM16.625 11.875L14.8042 13.6958L12.5321 11.4079L11.4079 12.5321L13.6958 14.8042L11.875 16.625H16.625V11.875Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFullScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_full_screen.7fe5a050.svg";
export { ForwardRef as ReactComponent };